import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
// import './index.css';
import App from './App';
import store from './Redux/redux/store';
import reportWebVitals from './reportWebVitals';
// ##### 23-09-14 Komarov: Подключаем все CSS приложения
import './css';
// ##### 23-10-18 Komarov
import { MediaContextProvider } from './helpers/MediaConfig';
// ##### Komarov 2025-08-21
import { createPerformanceMeasure } from './hooks/usePerformanceMeasure';
// ##### Komarov 2025-08-26
import getDev from './helpers/getDevMode';
// ##### Komarov 2025-08-26

const getDevMode = () => getDev();
const devMode = getDevMode();
if (devMode) {
  window.techData = window.techData || {};
  window.techData.clientStart = performance.now();
  console.log('[performance] Client code started executing:', performance.now());
}

// ##### 25-04-26 Komarov
// ##### 24-07-26 Komarov: Удаляем страницы purePage из localStorage
function removeItemsByRegex(regex) {
  // Получаем все ключи из localStorage
  const keys = Object.keys(localStorage);

  // Итерируем по ключам и удаляем соответствующие элементы
  keys.forEach(key => {
    if (regex.test(key)) {
      localStorage.removeItem(key);
    }
  });
}

// Пример использования:
const regex = /^\d+:\d+:[a-z]{2}$/; // То же регулярное выражение, что и в предыдущем примере
removeItemsByRegex(regex);

// Start hydration
// ##### Komarov 2025-08-21
const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <Provider store={store}>
      <MediaContextProvider>
        <App />
      </MediaContextProvider>
    </Provider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  // Start hydration measurement
  let clientMeasure;
  if (devMode) {
    clientMeasure = createPerformanceMeasure('ClientHydration');
    clientMeasure.start();
  }
  // Hydrate for server-side rendered content
  ReactDOM.hydrate(app, rootElement, () => {
    let result;
    if (devMode) {
      result = clientMeasure.stop();
      console.log('🚀 Client hydration completed in', result.durationMs, 'ms');
    }
    // If server timing data is available
    if (devMode && window.__SERVER_TIMING__) {
      const totalTime = (window.__SERVER_TIMING__.serverRender + result.durationMs).toFixed(2);
      console.log('📊 Complete page load metrics:', {
        serverRender: window.__SERVER_TIMING__.serverRender,
        clientHydration: result.durationMs,
        totalTime: `${totalTime}ms`
      });
    }

    // Optional: Send to analytics
    if (window.analytics) {
      const metrics = {
        event: 'performance_metrics',
        server_render: window.__SERVER_TIMING__?.serverRender || 0,
        client_hydration: result.durationMs,
        total_time: window.__SERVER_TIMING__ ?
          (window.__SERVER_TIMING__.serverRender + result.durationMs) :
          result.durationMs
      };
      window.analytics.track(metrics);
    }
  });
} else {
  // Render for client-side only
  ReactDOM.render(app, rootElement);
}

// ##### 25-04-26 Komarov

/* ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
); */

// ##### 25-04-26 Komarov
// ##### 25-04-15 Komarov: отключил вызов функции репортирования о продуктивности приложения в случае production
if (process.env.NODE_ENV === 'development') {
  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  // ##### 25-04-15 Komarov: добавил вывод отчёта о продуктивности в консоль браузера
  reportWebVitals(console.log);
}
// ##### 25-04-26 Komarov
